var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.333496V13.6668H10.6667V9.00016H8V4.3335C8 2.12436 9.79087 0.333496 12 0.333496ZM10.6667 2.02016C10.1133 2.3335 9.33333 3.1135 9.33333 4.3335V7.66683H10.6667V2.02016ZM4 8.26683V13.6668H2.66667V8.26683C1.14517 7.95796 0 6.61283 0 5.00016V1.00016H1.33333V5.66683H2.66667V1.00016H4V5.66683H5.33333V1.00016H6.66667V5.00016C6.66667 6.61283 5.52147 7.95796 4 8.26683Z",
    fill: "#313131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForkIcon);
export default __webpack_public_path__ + "static/media/forkIcon.3a0604a7ed1dd5d764b68118c5eabc51.svg";
export { ForwardRef as ReactComponent };